import { useTelegram } from '../../../assets/hooks/useTelegram';
import { useHapticPress } from '../../../assets/hooks/useHapticPress';
import './BottomActionButton.css';

function BottomActionButton({
  children,
  className,
  buttonClassName,
  type = 'button',
  ...props
}) {
  const { webApp } = useTelegram();
  const hapticProps = useHapticPress(webApp);
  const wrapperClassName = ['bottom-action-button', className]
    .filter(Boolean)
    .join(' ');
  const innerClassName = ['bottom-action-button__button', buttonClassName]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapperClassName}>
      <button type={type} className={innerClassName} {...hapticProps} {...props}>
        {children}
      </button>
    </div>
  );
}

export default BottomActionButton;
